const Main = ({ children, isFullScreen = false }) => (
  <main className="h-full overflow-y-auto">
    <div className={`container mx-auto ${isFullScreen ? "" : "px-6 my-12"}`}>
      {children}
    </div>
  </main>
);

export default Main;
